import React from 'react'

function HelpAdmin() {
  return (
    <div>TBA</div>
  )
}

export default HelpAdmin